// Provides the CASL ability to the React tree. Per project convention this uses
// Context + hooks only — no new Redux state. It reads the authenticated user's
// identity (email/username) from the existing auth slice and derives the ability
// with useMemo. Feature permissions come from userAccess.js (hardcoded for now);
// the legacy `is_admin` array is NOT used.
//
// react-redux@6 has no hooks (useSelector landed in v7), so auth is read via
// connect(). The ability is published through our own AbilityContext (see
// AbilityContext.js) rather than @casl/react, which requires React 18.

import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { AbilityContext } from './AbilityContext';
import { defineAbilityFor } from './abilities';
import { getUserAccess } from './userAccess';

function AbilityProvider({ userId, email, children }) {
  const ability = useMemo(() => defineAbilityFor(getUserAccess({ userId, email })), [userId, email]);

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
}

// Auth lives under state.auth (see redux/reducers.js). Read-only — identity only.
const mapStateToProps = (state) => ({
  userId: state.auth.userId,
  email: state.auth.email,
});

export default connect(mapStateToProps)(AbilityProvider);
